import React from 'react';

const ContactUsForm = () => {
  return (
    <div
      id="contactUsFormDiv"
      className="shadow-lg tablet:shadow-blue rounded px-8 pt-6 pb-8 mb-4 tablet:w-2/3 mx-auto mt-6 bg-gradient-to-r from-slate-500 via-slate-300 to-slate-500"
    >
      <form
        action="https://formspree.io/f/myyqvyka"
        method="POST"
        className="space-y-4"
      >
        <h1 className="text-xl font-bold mb-4 font-sharetech text-center">
          Contact Us
        </h1>
        <div>
          <label
            htmlFor="subject"
            className="block text-txtColor1 text-sm font-bold mb-2 tracking-tighter"
          >
            Subject:
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            className="bg-black shadow-md shadow-purple appearance-none rounded w-full py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline"
            required
          />
        </div>
        <div>
          <label
            htmlFor="name"
            className="block text-txtColor1 text-sm font-bold mb-2"
          >
            Name:
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            className="bg-black shadow-md shadow-purple appearance-none rounded w-full py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div>
          <label
            htmlFor="phoneNumber"
            className="block text-txtColor1 text-sm font-bold mb-2"
          >
            Phone:
          </label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            required
            className="bg-black shadow-md shadow-purple appearance-none rounded w-full py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div>
          <label
            htmlFor="email"
            className="block text-txtColor1 text-sm font-bold mb-2"
          >
            Email:
          </label>
          <input
            type="email"
            id="email"
            name="_replyto"
            className="bg-black shadow-md shadow-purple appearance-none rounded w-full py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div>
          <textarea
            name="note"
            placeholder="Comments or Notes"
            className="bg-black shadow-lg appearance-none rounded w-full py-2 px-3 text-white leading-tight h-24 shadow-accent2"
          ></textarea>
        </div>
        <div>
          <input
            type="submit"
            value="Submit"
            className="bg-gradient-to-r from-pink to-blue hover:bg-accent2 text-txtColor1 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full tablet:w-auto"
          />
        </div>
      </form>
    </div>
  );
};

export default ContactUsForm;
